import { render, staticRenderFns } from "./addons.vue?vue&type=template&id=0f304301&scoped=true"
import script from "./addons.vue?vue&type=script&lang=js"
export * from "./addons.vue?vue&type=script&lang=js"
import style0 from "./addons.vue?vue&type=style&index=0&id=0f304301&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f304301",
  null
  
)

export default component.exports